import TemplateView from "../../../TemplateView"
import {setEventPreventHiding} from '../../../panels/utils'
import {BulkOperationType} from '../constants'
import messageResource from '../../../messageResource'
import $ from 'jquery'
import SimpleTooltip from '../../../SimpleTooltip'

export default class BulkOperationsPanel extends TemplateView {
    constructor({
        onCopyToClick = () => {},
        onMoveToClick = () => {},
        onAssignToClick = () => {},
        onChangeStatusClick = () => {},
        onDeleteClick = () => {},
        onClearSelectionClick = () => {}
    }) {
        super()

        this.onCopyToClick = onCopyToClick;
        this.onMoveToClick = onMoveToClick
        this.onAssignToClick = onAssignToClick
        this.onChangeStatusClick = onChangeStatusClick
        this.onDeleteClick = onDeleteClick
        this.onClearSelectionClick = onClearSelectionClick

        this.state = {
            selectedTasksCount: 0,
            existingTasksCount: 0,
            empty: true,
            copyToButtonPressed: false,
            moveToButtonPressed: false,
            assignToButtonPressed: false,
            changeStatusButtonPressed: false,
            changeStatusButtonVisible: true,
            deleteButtonPressed: false,
            assignToButtonDisabled: false,
            assignToButtonVisible: false,
        }

        this.onStatePropertyChanged('assignToButtonVisible', (visible) => this.$assignToButton.toggle(visible))
        this.onAnyStatePropertyChanged(['selectedTasksCount', 'existingTasksCount'], () => this._updateSelectionText())
        this.onStatePropertyChanged("empty", empty => this.$el.toggleClass("empty", empty))
        this.onStatePropertyChanged("copyToButtonPressed", pressed => this._toggleButtonPressed(this.$copyToButton, pressed))
        this.onStatePropertyChanged("moveToButtonPressed", pressed => this._toggleButtonPressed(this.$moveToButton, pressed))
        this.onStatePropertyChanged("assignToButtonPressed", pressed => this._toggleButtonPressed(this.$assignToButton, pressed))
        this.onStatePropertyChanged("changeStatusButtonPressed", pressed => this._toggleButtonPressed(this.$changeStatusButton, pressed))
        this.onStatePropertyChanged("deleteButtonPressed", pressed => this._toggleButtonPressed(this.$deleteButton, pressed))
        this.onStatePropertyChanged("assignToButtonDisabled", assignToButtonDisabled => {
            this.$assignToButton.toggleClass("disable", assignToButtonDisabled)
            this.assignToTooltip.setEnabled(assignToButtonDisabled)
        })
        this.onStatePropertyChanged("changeStatusButtonVisible", (visible)  => {
            this.$changeStatusButton.toggle(visible)
        })
    }

    templateHtml() {
        return "<div class='bulkOperationsPanel'>" +
               "  <div class='title'>" +
               "    <span class='actual'></span>" +
               "    <span class='existing'></span>" +
               "    <span class='postfix'></span>" +
               "  </div>" +
               "  <div class='copyTo button'><%-copyTo%></div>" +
               "  <div class='moveTo button'><%-moveTo%></div>" +
               "  <div class='assignTo button'><%-assignTo%></div>" +
               "  <div class='changeStatus button'><%-changeStatus%></div>" +
               "  <div class='delete button'><%-deleteLabel%></div>" +
               "  <div class='clearSelection'><span><%-clearSelection%></span></div>" +
               "</div>"
    }

    afterRender() {
        this.$title = this.find(".title")
        this.$copyToButton = this.find(".copyTo").click((e) => {
            setEventPreventHiding(e, BulkOperationType.COPY)
            this.onCopyToClick(this.$copyToButton)
        })
        this.$moveToButton = this.find(".moveTo").click((e) => {
            setEventPreventHiding(e, BulkOperationType.MOVE)
            this.onMoveToClick(this.$moveToButton)
        })
        this.$assignToButton = this.find(".assignTo").click((e) => {
            if (!this.state.assignToButtonDisabled) {
                setEventPreventHiding(e, BulkOperationType.CHANGE_ASSIGNMENTS)
                this.onAssignToClick(this.$assignToButton)
            }
        }).hide() // sync with initial state

        this.$changeStatusButton = this.find(".changeStatus").click((e) => {
            setEventPreventHiding(e, BulkOperationType.CHANGE_STATUS)
            this.onChangeStatusClick(this.$changeStatusButton)
        })
        this.$deleteButton = this.find(".delete").click((e) => {
            setEventPreventHiding(e, BulkOperationType.DELETE)
            this.onDeleteClick(this.$deleteButton)
        })
        this.find(".clearSelection").click(() => this.onClearSelectionClick())

        this.assignToTooltip = new SimpleTooltip({
            text: messageResource.getMessage('task.list.create_pop_up.disabled_button'),
        }).init($('body'))
        this.assignToTooltip.subscribeToMouseEvents(this.$assignToButton)
        this.assignToTooltip.disable()
    }

    messageKeys() {
        return {
            copyTo: "task.list.bulk_operations.copy_to",
            moveTo: "task.list.bulk_operations.move_to",
            assignTo: "task.list.bulk_operations.assign_to",
            changeStatus: "task.list.bulk_operations.change_status",
            deleteLabel: "task.list.bulk_operations.delete",
            clearSelection: "task.list.bulk_operations.clear_selection"
        }
    }

    _toggleButtonPressed($button, pressed) {
        $button.toggleClass("pressed", pressed)
    }

    _updateSelectionText = () => {
        const {selectedTasksCount, existingTasksCount} = this.state
        const all = selectedTasksCount === existingTasksCount

        const actualText = all
                           ? messageResource.getMessage('task.list.bulk_operations.selection_title.all', [selectedTasksCount])
                           : `${selectedTasksCount}`

        const of = all ? '' : messageResource.getMessage('task.list.bulk_operations.selection_title.of', [existingTasksCount])

        const postfix = existingTasksCount === 1
                        ? messageResource.getMessage('task.list.bulk_operations.selection_title.singular')
                        : messageResource.getMessage('task.list.bulk_operations.selection_title.plural')

        this.$title.find('.actual').text(actualText)
        this.$title.find('.existing').text(of)
        this.$title.find('.postfix').text(postfix)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/BulkOperationsPanel.js